import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      Ĉiuj scias, ke en pasinto oni ne kutimis fari demandojn. Infano ne rajtis demandi pliaĝulojn, studantoj – instruistojn, oficistoj – estrojn. La kialo klaras:  la loko en hierarkio. Se homo ne povis respondi al demando, li kvazaŭ montris sian nesufiĉan nivelon, “perdis la vizaĝon”. Do, prefere ne riski kaj tute malebligi tian neoportunan situacion.
    </p>
    
    <p class="mb-3">
      Nun venis nova epoko, epoko de plena demokratio. For socian hierarkion, des pli hierarkion de scioj! Kial scii “enkape”, kiam eblas tuj trovi informon enrete?
    </p>
    
    <p class="mb-3">
      Regas nur asertoj, severaj asertoj… Demandoj evitendas…
    </p>
    
    <p class="mb-3">
      Tamen, mia profesio estas demandi. Mi ricevas salajron pro tio. 
    </p>
    
    <p class="mb-3">
      Mi estas trejnisto de Intelektaj Ludoj 😀
    </p>
    `
  )
}

const itemName = {
  esp: 'Neoportuna situacio'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item; 